import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { SelectBarProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardSelectBar = dynamic(
  () => import("./DashboardSelectBarSsr").then((mod) => mod.DashboardSelectBarSsr),
  { ssr: false }
);

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardSelectBar = forwardRef<HTMLDivElement, SelectBarProps>((props, ref) => (
  <DynamicDashboardSelectBar {...props} forwardedRef={ref} />
));

DashboardSelectBar.displayName = "DashboardSelectBar";
